<template>
  <div :id="id" class="container-select" :style="styledFocusSelect(filterActive, 'border')">
    <div class="container-button white-space-now-wrap d-flex align-item-center gap-2" @click="toggleSelect">
      <span :style="styledFocusSelect(filterActive, 'color')"><b>{{ label }}: </b></span>
      <span v-if="!selectedItem.id || !selectedItem.name" class="option-selecione" :style="styledFocusSelect(filterActive, 'color')">Selecione</span>
      <span :style="styledFocusSelect(filterActive, 'color')">{{ selectedItem.name }}</span>
      <SVGIcon v-if="!standalone && !fixo" iconName="icon-close" :size="8" @click.stop="onExcluded" />
    </div>
    <div class="select-filtro" :class="{ 'opens-up': abrirParaCima, 'abre-esquerda': abrirParaEsquerda }" v-if="filterActive">
      <div class="container-search">
        <i class="fa fa-search icn-search"></i>
        <input
          type="text"
          class="ipt-search"
          :placeholder="searchPlaceholder"
          v-model="search"
          @input="aoDigitar"
        />
      </div>
      <div v-if="buscaRemota && buscando" class="p-2">
        <SpinnerLoading :size="16" />
      </div>
      <div class="container-items">
        <div 
          class="item"
          @click="selectItem({ id: '', name: '' })"
        >
          Selecione
        </div>
        <div
          v-for="(item, index) in filteredItems"
          :key="index"
          class="item"
          :class="{ 'selected': selectedItem.id === item.id }"
          @click="selectItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SVGIcon from '../../SvgIcon.vue';
import SpinnerLoading from '../../../../shared/SpinnerLoading.vue';
import { removeAccents } from '../helpers';

const EVENTO_ABRIR_SELECT = 'filtro:select:abrir';
const ESPACO_MINIMO_ABAIXO = 400;

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: "Item",
    },
    searchPlaceholder: {
      type: String,
      default: "Busque pelo campo",
    },
    filtro_id: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: false,
      default: ''
    },
    filtro_default: {
      type: Boolean,
      default: false
    },
    standalone: {
      type: Boolean,
      default: false
    },
    fixo: {
      type: Boolean,
      default: false
    },
    buscaRemota: {
      type: Boolean,
      default: false
    },
    buscando: {
      type: Boolean,
      default: false
    }
  },
  emits: ['atualizar', 'buscar'],
  components: {
    SVGIcon,
    SpinnerLoading,
  },
  data() {
    return {
      search: "",
      filterActive: false,
      debounceTimeout: null,
      abrirParaCima: false,
      abrirParaEsquerda: false,
    };
  },
  computed: {
    filteredItems() {
      if (this.buscaRemota) return this.items;

      return this.items.filter((item) => {
        if (!item?.name && item?.name !== 0) return false;
        const name = removeAccents(String(item.name).toLowerCase());
        const search = removeAccents(this.search.toLowerCase());
        return name.includes(search);
      });
    },
  },
  methods: {
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    aoDigitar() {
      if (!this.buscaRemota) return;
      this.debounce(() => this.$emit('buscar', this.search), 300)();
    },
    toggleSelect() {
      this.filterActive = !this.filterActive;

      if (this.filterActive) {
        document.dispatchEvent(new CustomEvent(EVENTO_ABRIR_SELECT, { detail: { id: this.id } }));
        this.$nextTick(() => this.ajustaDirecaoAbertura());
      } else {
        this.abrirParaCima = false;
        this.abrirParaEsquerda = false;
      }
    },
    ajustaDirecaoAbertura() {
      const container = document.getElementById(this.id);
      if (!container) return;

      const retangulo = container.getBoundingClientRect();
      this.abrirParaCima = retangulo.bottom + ESPACO_MINIMO_ABAIXO > window.innerHeight;

      const dropdown = container.querySelector('.select-filtro');
      if (!dropdown) return;
      const retanguloDropdown = dropdown.getBoundingClientRect();
      this.abrirParaEsquerda = retangulo.left + retanguloDropdown.width > window.innerWidth;
    },
    selectItem(item) {
      if (!item) {
        console.warn('Item inválido selecionado');
        return;
      }
      const resultItem = item.id === this.selectedItem.id ? {
        id: "",
        name: "",
      } : item;

      this.$emit("atualizar", resultItem);
      this.filterActive = false;
    },
    onExcluded() {
      if (this.standalone) {
        this.$emit('atualizar', { id: '', name: '' });
        return;
      }
      this.$store.commit('removeFiltro', this.filtro_id);
      this.$removeFiltroDaURL(this.filtro_id, this.path);
      this.$filtroDb.removeFiltro(this.path, this.filtro_id)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    styledFocusSelect(filterActive, style) {
      if(!filterActive) return;

      if (style === 'color')
        return 'color: var(--maino-blue-hover)';
      else if (style === 'border')
        return 'border-color: var(--maino-blue-hover)';
    }
  },
  mounted() {
    this.fecharAoClicarFora = (event) => {
      if (event.target.closest(`#${this.id}`) === null && this.filterActive) {
        this.filterActive = false;
        this.abrirParaCima = false;
        this.abrirParaEsquerda = false;
      }
    };
    this.fecharAoAbrirOutro = (event) => {
      if (event.detail.id !== this.id && this.filterActive) {
        this.filterActive = false;
        this.abrirParaCima = false;
        this.abrirParaEsquerda = false;
      }
    };
    document.addEventListener('click', this.fecharAoClicarFora);
    document.addEventListener(EVENTO_ABRIR_SELECT, this.fecharAoAbrirOutro);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.fecharAoClicarFora);
    document.removeEventListener(EVENTO_ABRIR_SELECT, this.fecharAoAbrirOutro);
  },
};
</script>
